import { render, staticRenderFns } from "./CollectionList.vue?vue&type=template&id=16be80d6&scoped=true"
import script from "./CollectionList.vue?vue&type=script&lang=js"
export * from "./CollectionList.vue?vue&type=script&lang=js"
import style0 from "./CollectionList.vue?vue&type=style&index=0&id=16be80d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16be80d6",
  null
  
)

export default component.exports